import { t } from '@lingui/macro';

import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { FetchCountryFooterLinksResponse } from '@rover/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import { getCountryUrlPrefixFromExpress } from '@rover/utilities/countryCode';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const COUNTRY_FOOTER_LINKS_URL: string = fullApiUrl('frontend/country-footer-links/');
export const get = async (): Promise<FetchCountryFooterLinksResponse> => {
  const ai = getAxiosInstance();
  const countryCode = getCountryUrlPrefixFromExpress();

  try {
    const { data } = await ai.get<Snakeify<FetchCountryFooterLinksResponse>>(
      COUNTRY_FOOTER_LINKS_URL,
      {
        params: {
          country_url_prefix: countryCode,
        },
        withCredentials: true,
      }
    );
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, t`There was an error while fetching country links.`);
  }
};
export default {
  get,
};
